import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

export const developer: RouteRecordRaw = {
  name: 'admin.developer',
  path: 'developer',
  component: () => import('pages/developer/DeveloperPortal.vue'),
  redirect: { name: 'admin.developer.docs' },
  meta: {
    roles: [
      Roles.SuperAdmin,
      Roles.OrgAdmin,
      Roles.CenterAdmin,
      Roles.OfficeStaff,
      Roles.RoomStaff,
    ],
    supportedPlatforms: ['desktop', 'mobile', 'native'],
    excludeEnv: ['PRD', 'UAT'], // Only available in DEV environment
  },
  children: [
    {
      name: 'admin.developer.docs',
      path: 'docs',
      component: () => import('pages/developer/docs/DocsIndex.vue'),
      meta: {
        roles: [
          Roles.SuperAdmin,
          Roles.OrgAdmin,
          Roles.CenterAdmin,
          Roles.OfficeStaff,
          Roles.RoomStaff,
        ],
        supportedPlatforms: ['desktop', 'mobile', 'native'],
        excludeEnv: ['PRD', 'UAT'],
      },
    },
    {
      name: 'admin.developer.ui-library',
      path: 'ui-library',
      component: () => import('pages/developer/ui-library/UILibraryIndex.vue'),
      meta: {
        roles: [
          Roles.SuperAdmin,
          Roles.OrgAdmin,
          Roles.CenterAdmin,
          Roles.OfficeStaff,
          Roles.RoomStaff,
        ],
        supportedPlatforms: ['desktop', 'mobile', 'native'],
        excludeEnv: ['PRD', 'UAT'],
      },
    },
  ],
}

